import React from 'react'
import PropTypes from 'prop-types'

import { default as UIPill } from '@anvilco-pkg/ui/components/Pill'

import UniversalLink from 'components/UniversalLink'

export { CLASS_NAME as PILL_CLASS_NAME } from '@anvilco-pkg/ui/components/Pill'

const Pill = ({ to, ...others }) => {
  return (
    <UIPill
      to={to}
      linkComponent={to ? UniversalLink : undefined}
      {...others}
    />
  )
}

Pill.Workflows = ({ to, ...others }) => (
  <UIPill.Workflows
    {...others}
    to={to}
    linkComponent={to ? UniversalLink : undefined}
  />
)
Pill.PDFServices = ({ to, ...others }) => (
  <UIPill.PDFServices
    {...others}
    to={to}
    linkComponent={to ? UniversalLink : undefined}
  />
)
Pill.ESign = ({ to, ...others }) => (
  <UIPill.ESign
    {...others}
    to={to}
    linkComponent={to ? UniversalLink : undefined}
  />
)

export default Pill

Pill.propTypes = {
  to: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
}
